import { toNumber } from 'lodash';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useWindow } from 'hooks/useWindow';
import { media } from '../constants';
import messages from '../messages';
import Styled from '../styles';
import { PriceDetailsWrapper } from './styles';

function ValuationPrice({
  price,
  scrollToWidget,
  showDetailButton,
}: DetailsProps) {
  const [priceCounter, setPriceCounter] = useState('');
  const displayPriceRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (price) {
      animateValue({
        start: 0,
        end: toNumber(price.replace(/,/g, '').slice(1)),
        duration: 2000,
        updatePrice,
      });
    }
  }, [price]);

  function updatePrice(updatedPrice: string) {
    setPriceCounter(updatedPrice);
  }

  return price ? (
    <div className="priceWrapper">
      <h1 ref={displayPriceRef}>{priceCounter}</h1>
      {showDetailButton ? (
        <p onClick={scrollToWidget} aria-hidden>
          <FormattedMessage {...messages.viewMoreDetails} />
        </p>
      ) : null}
    </div>
  ) : (
    <div className="value-image">
      <Styled.WidgetOverlayImage>
        <Image src={media.lockIcon} width={31} height={31} alt="" />
      </Styled.WidgetOverlayImage>
      <Image
        src={media.valueBlur}
        width={250}
        height={80}
        alt="price-preview"
      />
    </div>
  );
}

function ValuationPriceMobile({
  price,
  scrollToWidget,
  showDetailButton,
}: DetailsProps) {
  const { w: width } = useWindow();

  return (
    <PriceDetailsWrapper>
      {width <= 768 ? (
        <ValuationPrice
          price={price}
          scrollToWidget={scrollToWidget}
          showDetailButton={showDetailButton}
        />
      ) : null}
    </PriceDetailsWrapper>
  );
}

function animateValue({
  start,
  end,
  duration,
  updatePrice,
}: AnimateValueProps) {
  let startTimestamp: number | null = null;

  function step(timestamp: number) {
    if (!startTimestamp) startTimestamp = timestamp;

    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    const price = Math.floor(progress * (end - start) + start);

    updatePrice(`$${price.toLocaleString('en-US')}`);

    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

interface AnimateValueProps {
  start: number;
  end: number;
  duration: number;
  updatePrice: (price: string) => void;
}

interface DetailsProps {
  price: string | null;
  scrollToWidget: () => void;
  showDetailButton: boolean;
}

export default ValuationPriceMobile;
